import {
  REQUEST_CAMPAIGN_CATEGORY_PARENT_LIST,
  REQUEST_CAMPAIGN_CATEGORY_LIST,
  REQUEST_CAMPAIGN_CATEGORY_LIST_FOR_CREATE,
} from './mutation-types'

export default {
  [REQUEST_CAMPAIGN_CATEGORY_PARENT_LIST](state, receivedData) {
    state.campaignCategoryParentList = receivedData
  },
  [REQUEST_CAMPAIGN_CATEGORY_LIST](state, receivedData) {
    state.campaignCategoryList = receivedData.content
    state.campaignCategoryListCount = receivedData.totalElements
  },
  [REQUEST_CAMPAIGN_CATEGORY_LIST_FOR_CREATE](state, receivedData) {
    state.campaignCategoryListForCreate = receivedData
  },
}